import { Injectable } from "@angular/core";
import { DataAccess } from "../dataaccess/data.access";
import { IdCardUtil } from "../modules/student-engagement/id-cards/id.card.util";
import { DBContact } from "../modules/student-housing/student.housing.service";

@Injectable({ providedIn: "platform" })
export class CardService {
    async getConfigs() {
        const params = DataAccess.params({ caller: "CardService.getConfigs" });
        const configs = await DataAccess.get<DBCardConfig[]>(`/cards/list.json?${params}`);
        return configs.map(IdCardUtil.fromDbCard);
    }

    async getConfig(id: number) {
        const params = DataAccess.params({ id, caller: "CardService.getConfig" });
        const card = await DataAccess.get<DBCardConfig>(`/cards/card.json?${params}`);
        return IdCardUtil.fromDbCard(card);
    }

    async putConfig(card: CardConfig) {
        const payload = IdCardUtil.toDbCard(card);
        const params = DataAccess.params({ caller: "CardService.putConfig" });
        await DataAccess.put<void>(`/cards/card.json?${params}`, payload);
    }

    async deleteConfig(id: number) {
        const params = DataAccess.params({ id, caller: "CardService.deleteConfig" });
        await DataAccess.delete<void>(`/cards/card.json?${params}`);
    }

    async getContactFromInternalId(internalId: string) {
        const params = DataAccess.params({ internalId, caller: "CardService.getContactFromInternalId" });
        return await DataAccess.get<DBContact>(`/cards/contact.json?${params}`);
    }

    async getCardRegexes() {
        const params = DataAccess.params({ caller: "CardService.getCardRegexes" });
        return await DataAccess.get<string[][]>(`/cards/regexes.json?${params}`);
    }
}

export type CardConfig = Pick<DBCardConfig, "id" | "name" | "description"> & { tracks: RegexConfig[][] };
export type RegexConfig = Pick<DBRegexConfig, "id" | "regex" | "label" | "optional" | "mapTo"> & {
    length: {
        type: "fixed" | "range" | "any";
        min: number;
        max: number;
    };
    characterSets: {
        numbers: boolean;
        letters: boolean;
        specific: {
            selected: boolean;
            characters: string;
        };
    };
    exact: {
        selected: boolean;
        text: string;
    };
};

export type DBCardConfig = {
    id?: number;
    name: string;
    description: string;
    tracks: DBRegexConfig[][];
};

export type DBRegexConfig = {
    id?: number;
    regex?: string;
    label: string;
    minLength?: number;
    maxLength?: number;
    allowDigits: boolean;
    allowLetters: boolean;
    allowSpecific?: string;
    exact?: string;
    optional: boolean;
    mapTo: "none" | "internalId";
};
